module.exports = __webpack_public_path__ + "img/icon-filter.92bc5247.svg";